<div id="onboarding-payment-page">

  <div class="container-state-img">
    <img ngSrc="assets/images/payment-success.svg" alt="Icon payment success" height="80" width="80">
  </div>

  <app-onboarding-header
    title="Paiement validé"
    content="Bravo 😀, votre paiement a bien été validé. Démarrons l'aventure ensemble 🤩🚀 !">
    [isStepperTitle]="true">
  </app-onboarding-header>

  <div class="container-actions">
    <button mat-stroked-button (click)="goHome()"
            class="full-width size-xl base"
            type="button">
      <div class="icon">
        <img ngSrc="assets/images/icons/home.svg" alt="Icon home" width="24" height="24"> Retour à l'accueil
      </div>
    </button>
  </div>
</div>
